import { TableColumnMeta } from "ds/components/Table/types";

export const BLUEPRINTS_COLUMNS_STORAGE_KEY = "blueprintsColumnsConfig";

export enum BLUEPRINTS_COLUMN_ID {
  NAME = "NAME",
  DESCRIPTION = "DESCRIPTION",
  STATUS = "STATUS",
  SPACE = "SPACE",
  LABELS = "LABELS",
  UPDATED_AT = "UPDATED_AT",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 2000;

export const BLUEPRINTS_COLUMN_CONFIG: Record<BLUEPRINTS_COLUMN_ID, TableColumnMeta> = {
  [BLUEPRINTS_COLUMN_ID.NAME]: {
    id: BLUEPRINTS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 180,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [BLUEPRINTS_COLUMN_ID.DESCRIPTION]: {
    id: BLUEPRINTS_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [BLUEPRINTS_COLUMN_ID.STATUS]: {
    id: BLUEPRINTS_COLUMN_ID.STATUS,
    title: "Status",
    minWidth: 160,
    defaultWidth: 160,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [BLUEPRINTS_COLUMN_ID.SPACE]: {
    id: BLUEPRINTS_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 120,
    defaultWidth: 120,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [BLUEPRINTS_COLUMN_ID.LABELS]: {
    id: BLUEPRINTS_COLUMN_ID.LABELS,
    title: "Labels",
    minWidth: 120,
    defaultWidth: 120,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [BLUEPRINTS_COLUMN_ID.UPDATED_AT]: {
    id: BLUEPRINTS_COLUMN_ID.UPDATED_AT,
    title: "Updated at",
    minWidth: 160,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [BLUEPRINTS_COLUMN_ID.DROPDOWN]: {
    id: BLUEPRINTS_COLUMN_ID.DROPDOWN,
    title: "Blueprint actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};

export const BLUEPRINTS_SORT_CONFIG: Record<string, string> = {
  [BLUEPRINTS_COLUMN_ID.NAME]: "name",
  [BLUEPRINTS_COLUMN_ID.STATUS]: "state",
  [BLUEPRINTS_COLUMN_ID.SPACE]: "space",
  [BLUEPRINTS_COLUMN_ID.UPDATED_AT]: "updatedAt",
};
